export const PERSISTED_CURRENT_USER = '_persisted_current_user';
